export default __webpack_public_path__ + "static/dashboard-en-26d9941f7380c6a559252f02cc90ca62.mp4";